import * as React from 'react'

import { useTranslation } from '../../../hooks/useTranslation'
import { NameCell } from './NameCell'
import { ProviderCell } from './ProviderCell'
import { CostCell } from './CostCell'
import { DateAddedCell } from './DateAddedCell'
import { DeleteCell } from './DeleteCell'
import { StatusCell } from './StatusCell'
export const columns = [
  {
    accessorKey: 'name',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <NameCell {...props} />,
  },
  {
    accessorKey: 'provider',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <ProviderCell {...props} />,
  },
  {
    accessorKey: 'cost',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <CostCell {...props} />,
  },
  {
    accessorKey: 'date_added',
    filterFn: 'includesString',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <DateAddedCell {...props} />,
  },
  {
    accessorKey: 'status',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <StatusCell {...props} />,
    filterFn: (row, _columnId, filterValue) => {
      if (Array.isArray(filterValue)) {
        const savedCourse = row.original
        const { reminder } = savedCourse
        const statusValue =
          reminder && savedCourse.status === 'saved'
            ? 'reminder_created'
            : savedCourse.status
        return filterValue.includes(statusValue)
      }
      return true
    },
  },
  {
    accessorKey: 'delete',
    header: (props) => <BlankHeader {...props} />,
    cell: (props) => <DeleteCell {...props} />,
    enableSorting: false,
  },
]

function TableHeader({ column }) {
  const { t } = useTranslation('TableHeader')

  return <div className="font-roboto">{t(column.id)}</div>
}

function BlankHeader() {
  return <div className="font-roboto"></div>
}
